import { School } from "@axl-dev/school-sdk";
import { useEffect, useRef, useState } from "react";

import { navigateTo } from "../navigate-to";

import { useSdk } from "./useSdk";

export const useSchool = () => {
  const sdk = useSdk();
  const [school, setSchool] = useState<School>(sdk.school);
  const redirectOccured = useRef(false);

  /**
   * migration subscription
   */
  useEffect(() => {
    const dispose = sdk.hub.school.schoolMigration.subscribe((migration) => {
      setSchool((prev) => new School({ ...prev, migration }));
      // if migration is completed, then redirect to new domain
      const needRedirect = !redirectOccured.current && migration.isCompleted;
      if (needRedirect && migration.settings?.targetUrls?.school) {
        // ensure that we don't redirect twice
        redirectOccured.current = true;
        navigateTo(migration.settings?.targetUrls?.school, true);
      }
    });

    return () => dispose();
  }, [sdk.hub.school.schoolMigration]);

  return school;
};
